/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.localStorage = (function() {
	var sessionStorage = null;
	var locationItem = "";
	var tokenItem = "";
	
	function storageAvailable( type) {
		try {
			var storage = window[ type];
			var test = "test";
			storage.setItem( test, test);
			storage.removeItem( test, test);
		}
		catch(ex) {
			console.log( "test failed -  " + ex.message);
            expocadfx.element.elementById( "btnMenu").style.borderColor = "red";
			storage = null;
		}
        return storage;
	}
    
	function saveSalesInfo( value, loc) {
		sessionStorage.setItem( tokenItem, value);
		sessionStorage.setItem( locationItem, loc);
	}
    
    function getSalesToken( location, eventName) {
        var tmp = "";
		locationItem = eventName + "_location";
		tokenItem = eventName + "_token";
		sessionStorage = storageAvailable( "sessionStorage");
        if( sessionStorage) {
            tmp = sessionStorage.getItem( locationItem);
            if( tmp !== null && tmp !== undefined) {
                if( tmp === location) {
                    tmp = sessionStorage.getItem( tokenItem);
                    if( tmp !== null && tmp !== undefined) {
                        return tmp;
                    }
                }
            }
        }
        return "";
    }
	
	function removeSalesInfo() {
		sessionStorage.removeItem(tokenItem);
		sessionStorage.removeItem( locationItem);
	}
    
    return {
        saveSalesInfo: saveSalesInfo,
        getSalesToken: getSalesToken,
        removeSalesInfo: removeSalesInfo,
		storageAvailable: storageAvailable
    };
}());